import { OBSTACLE_SUBTYPE, OBSTACLE_TYPE } from "./../ENUM.js";
import * as SOUND_DATA from "./../SOUND_DATA.js";

export const DENSE = {
  isDark: true,
  startHealth: 10,
  timeAllowedSecs: 60,
  textColor: "#faffab",
  textColorHighlight: "#ffff00",
  bgColor: "#222f00",
  bgFadeAlpha: 0.5,
  gameplayAreaToCanvasLateralRatio: 0.6,
  controllerSpeedDamp: 48,
  player: {
    color: "#ff5b91",
    growthDivisor: 100,
    radius: 9,
  },
  obstacles: [
    {
      type: OBSTACLE_TYPE.BACKGROUND,
      total: 800,
      color_ar: [
        "#7366ff",
        "#b66e00",
        "#b67e4b",
        "#645716",
        "#e12500",
        "#a7222e",
        "#559950",
        "#c2709c",
        "#01744c",
        "#5d7600",
        "#f14d7e",
        "#a12751",
        "#0067be",
        "#5741c0",
        "#9b00a4",
        "#d66a5f",
      ],
      radiusRange: [1, 2],
      directionRange: [175, 185],
      speedRange: [0.001, 0.004],
    },
    {
      type: OBSTACLE_TYPE.COLLECT,
      subtype: OBSTACLE_SUBTYPE.FLOWER,
      collectSfx_ar: SOUND_DATA.ORDERED_POP_SFX_AR,
      total: 13,
      color_ar: ["#ffffff"],
      radiusRange: [40, 60],
      directionRange: [120, 240],
      speedRange: [1, 3],
      numAppendagesRange: [7, 9],
      rotationSpeedRange: [0.5, 0.8],
      shapeCenterRadiusDivisor: 3,
      shapeCenterColor_ar: ["#ffff00", "#ffab03"],
    },
    {
      type: OBSTACLE_TYPE.AVOID,
      subtype: OBSTACLE_SUBTYPE.FLOWER,
      total: 25,
      color_ar: ["#6f6f6f", "#c0c0c0", "#464646", "#9c9c9c"],
      radiusRange: [30, 55],
      directionRange: [120, 240],
      speedRange: [1, 3],
      numAppendagesRange: [7, 9],
      rotationSpeedRange: [0.03, 0.09],
      shapeCenterRadiusDivisor: 1.2,
      shapeCenterColor_ar: ["#6f6f6f", "#c0c0c0", "#464646", "#9c9c9c"],
    },
  ],
};
